import { render } from "./ShroffIncomeAccount.vue?vue&type=template&id=499d423a"
import script from "./ShroffIncomeAccount.vue?vue&type=script&lang=js"
export * from "./ShroffIncomeAccount.vue?vue&type=script&lang=js"

import "./ShroffIncomeAccount.vue?vue&type=style&index=0&id=499d423a&lang=css"

import exportComponent from "E:\\NC\\services\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__